import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import VueAnalytics from "vue-analytics";
import store from "./store";
import Vuesax from "vuesax";
import "boxicons";

import "vuesax/dist/vuesax.css";
import "boxicons/css/boxicons.min.css";

Vue.use(Vuesax, {
  colors: {
    primary: "#e30614", //#5b3cc4
    success: "rgb(23, 201, 100)",
    danger: "rgb(242, 19, 93)",
    warning: "rgb(255, 130, 0)",
    dark: "rgb(36, 33, 69)"
  }
});

Vue.use(VueAnalytics, {
  id: "UA-104380131-1",
  linkers: [
    "kuntokruunu.fi",
    "kuntokruunu.lataaopas.fi",
    "kuntokruunu.lataapassi.fi"
  ],
  router
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
